import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  getPagination,
  checkPermisson,
} from '../../selectors/common';
import {
  getRoleCreateCallback,
  getPermissions, getSelectedRoleId,
  getRolePermissions,
} from '../../selectors/admin';
import {
  PERMISSIONS,
  CONFIRM_MODAL_CONTENT,
} from '../../constants';
import RoleModal from '../../components/MenuItems/Admin/RoleModal';
import ConfirmationModal from '../../components/Modals/ConfirmationModal';
import RoleSettingsRows from './RoleSettingsRows';
import { aGetPermissions, aRemoveRole, aRoleInit, aSaveEditRole, aSaveNewRole, aSetPagination } from '../../reducers';
import { aRolePermissions } from '../../reducers/admin';
import { aSetFilters } from '../../reducers/common';

const mapToProps = (state) => ({
  pagination: getPagination(state),
  roleCreateCallback: getRoleCreateCallback(state),
  permissions: getPermissions(state),
  selectedRoleId: getSelectedRoleId(state),
  rolePermissions: getRolePermissions(state),
  checkPermisson: (payload) => checkPermisson(state, payload),
});

const actionsToProps = (dispatch) => ({
  setFilterData: (payload) => dispatch(aSetFilters(payload)),
  getRoles: (payload) => dispatch(aRoleInit(payload)),
  setPagination: (payload) => dispatch(aSetPagination(payload)),
  getPermissions: (payload) => dispatch(aGetPermissions(payload)),
  saveNewRole: (payload) => dispatch(aSaveNewRole(payload)),
  saveEditRole: (payload) => dispatch(aSaveEditRole(payload)),
  getRolePermissions: (payload) => dispatch(aRolePermissions(payload)),
  removeRole: (payload) => dispatch(aRemoveRole(payload)),
});

/**
 * @class
 * @property {object} props
 * @property {object} props.pagination Pagination settings
 * @property {boolean} props.roleCreateCallback
 * @property {Array} props.permissions All permisions
 * @property {number} props.selectedRoleId Selected role id
 * @property {Array} props.rolePermissions All permissions for one role
 * @property {boolean} props.checkPermisson Check if user have
 *  permission for specific action or view
 * @property {Function} props.setFilterData Filter roles
 * @property {Function} props.getRoles Get roles API
 * @property {Function} props.setPagination Change pagination page
 * @property {Function} props.getPermissions API call to get all permissions
 * @property {Function} props.saveNewRole API call for create new role
 * @property {Function} props.saveEditRole API call for edit role
 * @property {Function} props.getRolePermissions API call to get
 * permissions data for particular role
 * @property {Function} props.removeRole API call to remove one role
 */
class RolesSettings extends Component {
  constructor(props) {
    super(props);
    /**
     * @member {object}
     * @property {boolean} roleModalOpen
     * @property {boolean} confirmationModalOpen
     * @property {number} moreModalRoleId
     * @property {object} selectedRole
     * @property {boolean} isEditingRole
     * @property {boolean} isAddNewRole
     * @property {object} modalData
     */
    this.state = {
      roleModalOpen: false,
      confirmationModalOpen: false,
      moreModalRoleId: -1,
      selectedRole: {},
      isEditingRole: false,
      isAddNewRole: false,
      modalData: {},
    };

    /**
     * @member {object}
     */
    this.emptyRole = {
      name: '',
      description: '',
    };
    /**
     * @member {object}
     * @description Check of user have permission for some of actions
     * @property {boolean} add
     * @property {boolean} enableDisable
     * @property {boolean} remove
     * @property {boolean} edit
     */
    this.hasPermissionTo = {
      add: props.checkPermisson(PERMISSIONS.ADMIN_ROLES_ADD),
      enableDisable: props.checkPermisson(PERMISSIONS.ADMIN_ROLES_DISABLE_ENABLE),
      remove: props.checkPermisson(PERMISSIONS.ADMIN_ROLES_REMOVE),
      edit: props.checkPermisson(PERMISSIONS.ADMIN_ROLES_UPDATE),
    };
  }

  /**
   * Get roles and permissions
   *
   * @function
   * @returns {void}
   */
  componentDidMount() {
    this.refreshGrid();
  }

  /**
   * Refresh roles table
   *
   * @function
   * @returns {void}
   */
  refreshGrid = () => {
    this.props.getRoles();
  };

  /**
   * Toggle role menu modal
   *
   * @function
   * @param {object} role Role
   * @returns {void}
   */
  openMoreModal = (role) => {
    if (this.state.moreModalRoleId === role.roleId) {
      this.setState({
        moreModalRoleId: -1,
        selectedRole: role,
      });
    } else {
      this.setState({
        moreModalRoleId: role.roleId,
        selectedRole: role,
      });
    }
  };

  /**
   * Close Role Menu modal
   *
   * @function
   * @returns {void}
   */
  closeMoreModal = () => {
    this.setState({ moreModalRoleId: -1 });
  };

  /**
   * Open add roles modal
   *
   * @function
   * @returns {void}
   */
  openAddRoleModal = () => {
    this.setState({
      roleModalOpen: true,
      isAddNewRole: true,
    });
  };

  /**
   * Open edit role modal
   *
   * @function
   * @returns {void}
   */
  openEditRole = () => {
    this.setState({
      roleModalOpen: true,
      isEditingRole: true,
    });
  };

  /**
   * open confirmation modal function
   *
   * @function
   * @returns {void}
   */
  openConfirmationModal = () => {
    const confirmationRemoveModalData = { ...CONFIRM_MODAL_CONTENT.REMOVE_ROLE };
    confirmationRemoveModalData.additionalMessages = [this.state.selectedRole.name];
    this.setState({
      confirmationModalOpen: true,
      modalData: confirmationRemoveModalData,
    });
  };

  /**
   * Confirm modal for remove role
   *
   * @function
   * @returns {void}
   */
  confirmRemoveRole = () => {
    this.props.removeRole({ roleId: this.state.selectedRole.roleId });
    this.setState({
      confirmationModalOpen: false,
      moreModalRoleId: -1,
    });
  };

  /**
   * Close role modal
   *
   * @function
   * @returns {void}
   */
  closeRoleModal = () => {
    this.setState({
      roleModalOpen: false,
      isEditingRole: false,
      isAddNewRole: false,
      confirmationModalOpen: false,
    });
  };

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    return (
      <>
        {this.state.moreModalRoleId !== -1
        && <div className="overlay-mask overlay-mask--open" />}

        <div className="table-wrapper m-t-30">
          <div className="scroll-fade" />
          <div className={`table-responsive fix-10 ${this.state.moreModalRoleId !== -1 ? 'overflow-hidden' : ''}`}>
            <table className="table-style table-style--role" id="data-table">

              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name </th>
                  <th>Description</th>
                  <th>Creation Date</th>
                  <th>Created By</th>
                  <th>Status</th>
                  <th className="menu" aria-label="menu" />
                </tr>
              </thead>
              <tbody>
                <RoleSettingsRows
                  moreModalRoleId={this.state.moreModalRoleId}
                  openMoreModal={this.openMoreModal}
                  closeMoreModal={this.closeMoreModal}
                  refreshGrid={this.refreshGrid}
                  openEditRole={this.openEditRole}
                  removeRole={this.props.removeRole}
                  hasPermissionTo={this.hasPermissionTo}
                  openConfirmationModal={this.openConfirmationModal}
                />
              </tbody>
            </table>
          </div>
          {this.state.roleModalOpen ? (
            <div className="modal modal--open">
              <RoleModal
                rolePermissions={this.props.rolePermissions}
                selectedRoleId={this.props.selectedRoleId}
                permissions={this.props.permissions}
                getRolePermissions={this.props.getRolePermissions}
                closeRoleModal={this.closeRoleModal}
                role={this.state.isAddNewRole ? this.emptyRole : this.state.selectedRole}
                isEditingRole={this.state.isEditingRole}
                isAddNewRole={this.state.isAddNewRole}
                saveNewRole={this.props.saveNewRole}
                saveEditRole={this.props.saveEditRole}
                getPermissions={this.props.getPermissions}
                hasInputModal
                assignedLabel="Permissions"
                title="Role"
              />
            </div>
          ) : null}

          {this.state.confirmationModalOpen ? (
            <div className="modal modal--open">
              <ConfirmationModal
                modalData={this.state.modalData}
                cancel={this.closeRoleModal}
                openDialog={this.openConfirmationModal}
                confirmation={this.confirmRemoveRole}
              />
            </div>
          ) : null}
          {(this.state.roleModalOpen || this.state.confirmationModalOpen)
          && <div className="overlay-mask overlay-mask--open" />}

        </div>
        {this.hasPermissionTo.add && (
          <button
            className="btn btn-primary m-t-30"
            onClick={this.openAddRoleModal}
            type="button"
            id="addRoleBtn_RoleSettings"
          >
            Add role
          </button>
        )}
      </>
    );
  }
}

export default connect(mapToProps, actionsToProps)(RolesSettings);
